import {mergeConfig} from '../../configStore'
import {field} from '../field'
import {ExcerptField, FieldReturn} from '../../types'

const defaultProps: Partial<ExcerptField> = {
  title: 'Excerpt',
  name: 'excerpt',
  rows: 4,
}

export const excerpt = (props?: ExcerptField, mergeProps?: Partial<ExcerptField>): FieldReturn =>
  field('text', mergeConfig('excerpt', props, mergeProps, defaultProps))
